import Button from '../../../../components/Button/Button';
// import PreviewIcon from '../../../../assets/Icons/components/PreviewIcon';
import PublishIcon from '../../../../assets/Icons/components/PublishIcon';
import Section from '../Section/Section';
// import HelpIcon from '../../../../assets/Icons/components/HelpIcon';
import { useParams } from 'react-router-dom';
import { useGetSectionsQuery } from '@/services/plaintiffSheets/plaintiffSheetsEndpoint';
import PublishFactSheet from '../PublishFactSheet/PublishFactSheet';
import Popup from '@/components/Popup/Popup';
// import Icons from '../../../../assets/index';
import { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import AddSection from '../AddSection/AddSection';
import Panel from '@/components/Panel/Panel';

const SectionPage = () => {
  const { id } = useParams();
  const [isFactSheetOpen, setIsFactSheetOpen] = useState(false);
  const [selectedSectionId, setSelectedSectionId] = useState<string | null>(null);
  const [isAddSectionOpen, setIsAddSectionOpen] = useState(false);

  const { data: sectionData } = useGetSectionsQuery(
    {
      factSheetId: id || '',
    },
    {
      skip: !id,
    }
  );

  useEffect(() => {
    if (sectionData?.data?.pagedSections?.length > 0 && !selectedSectionId) {
      setSelectedSectionId(sectionData.data.pagedSections[0].section_id);
    }
  }, [sectionData, selectedSectionId]);

  // Handler for when a section is added
  const handleSectionAdded = (newSectionId: string) => {
    setSelectedSectionId(newSectionId);
    setIsAddSectionOpen(false);
  };

  return (
    <div className="flex flex-col h-full  gap-3 w-full">
      <div className="flex flex-col bg-white rounded-lg">
        {/* Header with Extra Bottom Margin */}
        <div className="flex justify-between items-center px-6 py-3 ">
          <p className="text-xl font-medium text-[#4F4F4F] truncate w-[500px]">
            {sectionData?.data?.fact_tittle}
          </p>

          <div className="flex items-center gap-2">
            {/* <HelpIcon /> */}

            {/* <Button startIcon={<PreviewIcon />}>Preview</Button>
            <Button> Save to Draft</Button> */}
            <Button
              size="md"
              startIcon={<PublishIcon />}
              color="success"
              onClick={() => setIsFactSheetOpen(true)}
            >
              Publish
            </Button>
          </div>
        </div>
      </div>
      <div className="overflow-y-auto h-full">
        <div className="flex flex-row h-full">
          <div className="w-[250px] flex-shrink-0 mr-2 h-full overflow-y-auto custom-scrollbar">
            {sectionData?.data?.pagedSections?.length > 0 && (
              <div className="bg-white rounded-lg p-4">
                {sectionData.data.pagedSections.map((item: any) => {
                  return (
                    <p
                      key={item?.section_id}
                      className={`bg-primary-200 hover:bg-ds-mc-blue-100 text-sm font-medium text-[#4F4F4F] cursor-pointer mb-1 py-2 px-3 break-words rounded ${selectedSectionId === item?.section_id ? 'bg-ds-mc-blue-100' : ''}`}
                      onClick={() => setSelectedSectionId(item?.section_id)}
                    >
                      {item?.title}
                    </p>
                  );
                })}
              </div>
            )}
            <Button
              onClick={() => setIsAddSectionOpen(true)}
              startIcon={<Plus />}
              className="bg-neutral-100 hover:bg-neutral-200 mt-2 w-full"
            >
              <span className="text-sm text-[#2B1AA3] font-medium">Add Section</span>
            </Button>
          </div>
          <div className="flex-1 h-full overflow-y-auto">
            <Section selectedSectionId={selectedSectionId} />
          </div>
        </div>
      </div>
      {isFactSheetOpen && (
        <Popup
          isOpen={isFactSheetOpen}
          title="Publish Plaintiff Fact Sheet"
          onClose={() => setIsFactSheetOpen(false)}
        >
          <PublishFactSheet
            closePopUp={() => {
              setIsFactSheetOpen(false);
            }}
          />
        </Popup>
      )}
      {isAddSectionOpen && (
        <Panel
          isOpen={isAddSectionOpen}
          onClose={() => setIsAddSectionOpen(false)}
          title="Add Section"
          size="medium"
        >
          <AddSection
            closePopUp={() => setIsAddSectionOpen(false)}
            onSectionAdded={handleSectionAdded}
            factSheetId={sectionData?.data?.fact_sheet_id}
          />
        </Panel>
      )}
    </div>
  );
};

export default SectionPage;
